import { hDeepCopy } from '@/utils/helpers';

// @vue/component
export default {
  name: 'BasicConfigurationElement',

  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
    name: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      inputIsValid: false,
      editedProject: null,
    };
  },

  created() {
    this.editedProject = hDeepCopy(this.project);
  },

  methods: {
    inputValidateInput(option) {
      if (!this.editedProject[option.configItem]) {
        this.inputIsValid = false;
        return;
      }

      if (option.inputType === 'number') {
        this.inputIsValid = false;
        if (/[^0-9]/i.test(this.editedProject[option.configItem])) {
          this.inputIsValid = false;
        } else {
          this.inputIsValid = true;
        }
      }
    },
    changeOption(configItem) {
      this.inputIsValid = false;
      this.$emit('changeOption', {
        configItem,
        newValue: this.editedProject[configItem],
      });
      this.$message({
        message: `Zapisano zmiany dla projektu: ${this.editedProject.name}`,
        type: 'success',
      });
    },
  },
};
